/* ============================================================
   MÉTODO CLARIDAD — UI base
   Scroll suave a la oferta · sticky CTA · acordeón · reveals · contadores
   Vanilla, sin dependencias.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1. Scroll suave — TODOS los CTA van a #oferta
     --------------------------------------------------------- */
  function initScrollCtas() {
    document.addEventListener('click', function (ev) {
      var link = ev.target.closest('[data-cl-scroll]');
      if (!link) return;

      // El destino sale del href del propio boton (#metodo, #oferta...).
      // Antes estaba hardcodeado a #oferta y todos los CTA iban ahi.
      var dest = link.getAttribute('href');
      var target = dest && dest.charAt(0) === '#' ? document.querySelector(dest) : null;
      if (!target) target = document.querySelector('#oferta');
      if (!target) return;

      ev.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      // Aviso de desarrollo: el producto de Shopify todavía no está creado.
      if (link.hasAttribute('data-cl-cart-pending')) {
        console.warn(
          '[CLARIDAD] Falta el ID de variante del producto. ' +
          'Cargalo en Personalizar tema → Configuración → "Metodo CLARIDAD (infoproducto)". ' +
          'Mientras tanto, el botón de compra hace scroll a la oferta.'
        );
      }
    });
  }

  /* ---------------------------------------------------------
     2. Sticky CTA — aparece apenas el hero sale de cuadro,
        se esconde cuando #oferta está visible (no compite con el botón real)
     --------------------------------------------------------- */
  function initSticky() {
    var sticky = document.querySelector('[data-cl-sticky]');
    // El aviso de carrito solo esta en el DOM si cart.item_count > 0, y lo
    // decide el servidor. Aca solo se descubre: comparte disparador y
    // listener con el sticky de abajo, para no tener dos lecturas de scroll.
    var aviso = document.querySelector('[data-cl-aviso]');
    if (!sticky && !aviso) return;

    var hero = document.querySelector('.cl-hero');
    var oferta = document.querySelector('#oferta');
    var footer = document.querySelector('.cl-footer');

    // Visibilidad por getBoundingClientRect en vez de IntersectionObserver:
    // una lectura por scroll ya throttleado es barata, y evita depender de
    // callbacks que no se entregan con la pestaña en segundo plano.
    function onScreen(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    function update() {
      // El disparador es el hero, no un porcentaje de la página. Antes era
      // "pasado el 30% del scroll", y en una página de ~25.000 px eso caia
      // recién en la seccion del mercado: el lector pasaba cuatro secciones
      // sin ningun boton a la vista. Apenas el hero sale de cuadro ya hay
      // proximo paso.
      var fueraDelHero = hero
        ? hero.getBoundingClientRect().bottom <= 0
        : window.scrollY > window.innerHeight;

      // Se esconde sobre la oferta y sobre el footer para no competir
      // con el botón real de compra.
      if (sticky) {
        var show = fueraDelHero && !onScreen(oferta) && !onScreen(footer);
        sticky.classList.toggle('is-visible', show);
      }

      // El aviso de arriba NO se esconde sobre la oferta: no compite con el
      // botón de compra, dice otra cosa —que hay un pago sin terminar— y esa
      // sigue siendo cierta ahí. Solo respeta el hero.
      if (aviso) aviso.classList.toggle('is-visible', fueraDelHero);
    }

    // Throttle por tiempo, NO por requestAnimationFrame: en una pestaña en
    // segundo plano rAF no corre, y con un flag "ticking" el sticky quedaba
    // trabado para siempre al volver. update() es barato (lecturas cacheadas).
    var last = 0;
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - last < 60) return;
      last = now;
      update();
    }, { passive: true });

    window.addEventListener('resize', update, { passive: true });

    update();
  }

  /* ---------------------------------------------------------
     3. Acordeón (FAQ) — altura animada, accesible
     --------------------------------------------------------- */
  function initAccordion() {
    var items = document.querySelectorAll('.cl-acc__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.cl-acc__btn');
      var panel = item.querySelector('.cl-acc__panel');
      if (!btn || !panel) return;

      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Acordeón exclusivo: cerrar los demás
        items.forEach(function (other) {
          if (other === item) return;
          var otherPanel = other.querySelector('.cl-acc__panel');
          var otherBtn = other.querySelector('.cl-acc__btn');
          other.classList.remove('is-open');
          if (otherPanel) otherPanel.style.height = '0px';
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (isOpen) {
          item.classList.remove('is-open');
          panel.style.height = '0px';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          panel.style.height = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Recalcular la altura del panel abierto si cambia el ancho
    window.addEventListener('resize', function () {
      var open = document.querySelector('.cl-acc__item.is-open .cl-acc__panel');
      if (open) open.style.height = open.scrollHeight + 'px';
    });
  }

  /* ---------------------------------------------------------
     4. Reveals al hacer scroll
     --------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.cl-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     5. Contadores animados — <span data-cl-count="95">
     --------------------------------------------------------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-cl-count]');
    if (!els.length) return;

    function run(el) {
      var end = parseFloat(el.getAttribute('data-cl-count'));
      if (isNaN(end)) return;
      var prefix = el.getAttribute('data-cl-prefix') || '';
      var suffix = el.getAttribute('data-cl-suffix') || '';
      var finalText = prefix + Math.round(end).toLocaleString('en-US') + suffix;

      // Si no hay animación posible, se escribe el número y listo.
      if (reduceMotion || document.visibilityState !== 'visible') {
        el.textContent = finalText;
        return;
      }

      var duration = 1100;
      var start = null;
      var done = false;

      // Red de seguridad: si la pestaña se va a segundo plano, rAF deja de
      // correr y el contador quedaría clavado en 0. Este timeout garantiza
      // que siempre termine mostrando la cifra correcta.
      var safety = window.setTimeout(function () {
        if (!done) { done = true; el.textContent = finalText; }
      }, duration + 400);

      function step(ts) {
        if (done) return;
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = prefix + Math.round(end * eased).toLocaleString('en-US') + suffix;
        if (p < 1) {
          window.requestAnimationFrame(step);
        } else {
          done = true;
          window.clearTimeout(safety);
        }
      }
      window.requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        run(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });

    els.forEach(function (el) { io.observe(el); });
  }


  /* ---------------------------------------------------------
     6. Escalera de precio — <div data-cl-ladder>

     El ancho de la barra sale del tiempo transcurrido del tramo, pero
     arranca en un piso configurable (data-cl-ladder-floor) en vez de en
     cero. La fecha no se muestra en ningun lado — el texto de urgencia
     es fijo y lo pinta Liquid — asi que aca solo se mueve la barra.
     --------------------------------------------------------- */
  function initLadder() {
    var els = [].slice.call(document.querySelectorAll('[data-cl-ladder]'));
    if (!els.length) return;

    var items = els.map(function (el) {
      return {
        el:    el,
        start: parseInt(el.getAttribute('data-cl-ladder-start'), 10),
        end:   parseInt(el.getAttribute('data-cl-ladder-end'), 10),
        floor: parseFloat(el.getAttribute('data-cl-ladder-floor')) || 0,
        over:  el.getAttribute('data-cl-ladder-over') || '',
        fill:  el.querySelector('[data-cl-ladder-fill]'),
        bar:   el.querySelector('[data-cl-ladder-bar]'),
        pct:   el.querySelector('[data-cl-ladder-pct]'),
        txt:   el.querySelector('[data-cl-ladder-txt]'),
        dead:  false
      };
    }).filter(function (it) {
      // Sin fechas validas no se toca nada: queda el piso que pinto Liquid.
      return it.fill && !isNaN(it.start) && !isNaN(it.end) && it.end > it.start;
    });

    if (!items.length) return;

    function tick() {
      var now = Date.now();
      var alive = false;

      items.forEach(function (it) {
        if (it.dead) return;

        if (it.end - now <= 0) {
          // Se acabo el tramo. La barra se clava en 100% (lo hace .is-over
          // en CSS) y el mensaje pasa al texto de vencido.
          it.el.classList.add('is-over');
          if (it.pct) it.pct.textContent = '100%';
          if (it.bar) it.bar.setAttribute('aria-valuenow', '100');
          if (it.txt && it.over) it.txt.textContent = it.over;
          it.dead = true;
          return;
        }

        alive = true;

        var span = it.end - it.start;
        var gone = Math.min(Math.max(now - it.start, 0), span) / span;
        var pct = it.floor + (100 - it.floor) * gone;
        var shown = Math.min(Math.round(pct), 99);

        it.fill.style.width = pct.toFixed(2) + '%';
        if (it.pct) it.pct.textContent = shown + '%';
        if (it.bar) it.bar.setAttribute('aria-valuenow', String(shown));
      });

      if (!alive && timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    var timer = window.setInterval(tick, 30000);
    tick();
  }

  /* ---------------------------------------------------------
     1b. Botones de compra — el carrito queda SIEMPRE en 1.

     El href del boton es /cart/add?id=...&quantity=1, que es un GET y
     SUMA una unidad cada vez que se toca. Con ocho botones de compra
     repartidos por la pagina, el lector que toca dos de ellos mientras
     baja llega al carrito con 2 unidades de un PDF y el doble del
     precio. Lo detecto Andrew el 2026-09-11 en su propio telefono.

     Aca se intercepta el clic y se fija la cantidad en 1 con
     /cart/update.js, que ESTABLECE la cantidad en vez de sumarla. Si
     update.js no llega a crear la linea (el producto no estaba en el
     carrito), se cae a /cart/add.js.

     Las rutas se derivan del propio href para respetar el prefijo de
     idioma que ponga Shopify. Y si algo falla —sin fetch, red caida,
     respuesta rara— se deja seguir el enlace original: peor es que el
     boton no haga nada.
     --------------------------------------------------------- */
  function initCartCtas() {
    if (!window.fetch) return;

    var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    document.addEventListener('click', function (ev) {
      var link = ev.target.closest('[data-cl-cart]');
      if (!link) return;

      var variant = link.getAttribute('data-cl-variant');
      var href = link.getAttribute('href') || '';
      if (!variant || href.charAt(0) !== '/') return;

      // /cart/add?id=... -> base '/cart'
      var base = href.split('?')[0].replace(/\/add$/, '');

      ev.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');

      function alCarrito() { window.location.href = base; }
      function comoSea() { window.location.href = href; }

      var updates = {};
      updates[variant] = 1;

      fetch(base + '/update.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function (cart) {
          var puesto = (cart.items || []).some(function (it) {
            return String(it.variant_id || it.id) === String(variant) && it.quantity === 1;
          });
          if (puesto) { alCarrito(); return null; }

          // update.js no creo la linea: agregarla explicitamente.
          return fetch(base + '/add.js', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ id: variant, quantity: 1 })
          }).then(function (r) {
            if (!r.ok) return Promise.reject(r);
            alCarrito();
          });
        })
        .catch(comoSea);
    });
  }

  /* --------------------------------------------------------- */
  function init() {
    initScrollCtas();
    initCartCtas();
    initSticky();
    initAccordion();
    initReveals();
    initCounters();
    initLadder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
